var exports = {
  "k": "xe564cbfb--a804db--container",
};

module.exports = exports;
